<template>
  <div class="parlay-builder" v-if="isVisible">
    <v-expansion-panel class="market-type-class" :class="marketSubType.name" v-for="marketSubType in marketSubTypesData" :key="marketSubType.name">
      <v-expansion-panel-content>
        <h3 slot="header">{{marketSubType.name}} - <span>{{ $t('Parlay.Builder') }}</span></h3>
        <div class="event" v-for="event in marketSubType.marketsByEvent" :key="event.eventData.idfoevent.toString()">
          <h3>{{event.eventData.eventname}}</h3>
          <div class="eventmarketgroup marketgroup">
            <markets
              :markets="[event.market]"
              :event="event.eventData"
              :diplayOnPage="'live-single-event'"
              :isbig3coupon="false">
            </markets>
          </div>
        </div>
      </v-expansion-panel-content>
    </v-expansion-panel>
  </div>
</template>

<script>
import Vue from 'vue'
import markets from '@/components/sports/bettingoffer/markets'
import BettingOffer from '@/components/mixins/BettingOffer'

export default {
  name: 'ParlayBuilder',

  props: [
    'marketGroup',
    'selectedSports',
    'isCollapsed'
  ],
  components: {
    markets
  },

  mixins: [
    BettingOffer
  ],

  data () {
    return {}
  },

  computed: {
    isVisible () {
      let mg = this.marketGroup
      return mg && mg.events && mg.events.length && mg.flags && mg.flags.includes('PRBL')
    },
    marketSubTypesData () {
      let marketSubTypes = []
      let filteredEvents = this.selectedSports && this.selectedSports.length
        ? this.marketGroup.events.filter(ev => ev.idfosport === this.selectedSports[0])
        : this.marketGroup.events

      filteredEvents.forEach(ev => {
        ev.markets.forEach(mk => {
          if (mk.marketlinetype !== 'PLPROPS' && !marketSubTypes.some(m => m.name === mk.name)) {
            let eventsWithMarket = filteredEvents.filter(ev => ev.markets.some(mkt => mkt.name === mk.name))
            marketSubTypes.push({
              name: mk.name,
              internalorder: mk.internalorder,
              marketsByEvent: eventsWithMarket.map(ev => ({
                eventData: ev,
                market: this.findMarket(ev, mk.name)
              }))
            })
          }
        })
      })

      return Vue._.orderBy(marketSubTypes, 'internalorder', 'asc')
    }
  },

  methods: {
    findMarket (event, name) {
      return event.markets.find(mk => mk.name === name)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
@import '~@/css/config'
@import "mixins"

.parlay-builder
  ul
    margin-bottom 5px
  .v-expansion-panel__container
    >>>.v-expansion-panel__header
      padding 5px
      h3
        margin 0
        padding 5px 0
    .v-expansion-panel__body
      h3
        font-size 13px
        padding 5px

.parlay-builder
  padding 0 5px
  @media mobile-big-and-below
    padding 0
  .v-expansion-panel
    margin-bottom 10px
    border-radius 10px
    box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15)
    .v-expansion-panel__container
      border none !important
      >>>.v-expansion-panel__header
          background var(--coupon-exp-panel-background) !important
          border-width var(--coupon-exp-panel-border-width)
          border-style var(--coupon-exp-panel-border-style)
          border-color var(--coupon-exp-panel-border-color)
          min-height unset
          color var(--coupon-exp-panel-color)  !important
          .v-expansion-panel__header__icon
            .v-icon
              color transparent!important
              vertical-align middle
              background var(--event-market-header-icon-down) no-repeat
              height 20px
              width 20px
              background-position center
      >>>.v-expansion-panel__body
        .event
          h3
            margin 0
            background var(--coupon-header-markets-bgr)
          .eventmarketgroup::after
            display none
        .selections-container
          .flex-more3-container
            .flex-item
              .selections
                padding 2px 8px !important
          .flex
            .selections-mobile
              .selection-wapper
                padding 2px 0
        .selections-in-columns
          .selections-container
            .selections
              padding 0px 0 5px 0

</style>



// WEBPACK FOOTER //
// src/components/sports/bettingoffer/ParlayBuilder.vue